import { Injectable } from '@angular/core';
import type { PalantirDialogRef } from '../dialog/dialog-ref.service';
import { PalantirDialogService } from '../dialog/dialog.service';
import { PalantirAttachmentsDialogComponent } from './attachments-dialog.component';
import type { PalantirAttachmentsDialogOptions } from './attachments-dialog.type';

@Injectable({
  providedIn: 'root',
})
export class PalantirAttachmentsDialogService {
  public constructor(private readonly palantirDialogService: PalantirDialogService) {}

  public openDialog(params?: PalantirAttachmentsDialogOptions): PalantirDialogRef {
    return this.palantirDialogService.openDialog(PalantirAttachmentsDialogComponent, {
      size: 'large',
      data: params,
    });
  }
}
